import React from 'react'
import NotFound from '../components/NotFound'

function Page404() {
  return (
    <NotFound/>
  )
}

export default Page404